/* eslint-disable jsx-a11y/no-static-element-interactions */
import { InputHTMLAttributes, useEffect, useRef, useState } from 'react';
import ContainerFlex from '../containerFlex';

import { BsSearch } from 'react-icons/bs';
import * as St from './styles';

export interface IOptionDate {
  id?: string | number;
  value?: string;
}

export type ISelectDate = {
  months?: IOptionDate[];
  days?: IOptionDate[];
  years?: IOptionDate[];
  label?: string;
  value?: string;
  valueDay?: string;
  valueYear?: string;
  disabled?: boolean;
  onChange?: (any) => void;
  onChangeDays?: (any) => void;
  onChangeYears?: (any) => void;
  onSearch?: () => void;
  showDay: boolean;
  showMonth: boolean;
  showYear: boolean;
} & InputHTMLAttributes<HTMLDivElement>;

const SelectDate = ({
  months,
  value,
  label,
  valueDay,
  valueYear,
  years,
  onChange,
  onChangeDays,
  onChangeYears,
  onSearch,
  days,
  readOnly,
  disabled,
  showDay = true,
  showMonth = true,
  showYear = true,
}: ISelectDate): JSX.Element => {
  const [isFocused, setIsFocused] = useState(false);
  const [isFocusedDays, setIsFocusedDays] = useState(false);
  const [isFocusedYears, setIsFocusedYears] = useState(false);
  const selectRef = useRef<HTMLDivElement>();
  const selectRefDays = useRef<HTMLDivElement>();
  const selectRefYears = useRef<HTMLDivElement>();

  const valueSelected = months.find((el) => el.id === value);
  const valueDaySelected = days.find((el) => el.id === valueDay);
  const valueYearSelected = years.find((el) => el.id === valueYear);

  const handleSelect = (el: IOptionDate): void => {
    onChange(el.id);
    setIsFocused(false);
  };

  const handleSelectDays = (el: IOptionDate): void => {
    onChangeDays(el.id);
    setIsFocused(false);
  };

  const handleSelectYears = (el: IOptionDate): void => {
    onChangeYears(el.id);
    setIsFocused(false);
  };

  const handleToggleFocus = () => {
    if (!readOnly) setIsFocused((prev) => !prev);
    setIsFocusedDays(false);
    setIsFocusedYears(false);
  };

  const handleToggleFocusDays = () => {
    if (!readOnly) setIsFocusedDays((prev) => !prev);
    setIsFocused(false);
    setIsFocusedYears(false);
  };

  const handleToggleFocusYears = () => {
    if (!readOnly) setIsFocusedYears((prev) => !prev);
    setIsFocused(false);
    setIsFocusedDays(false);
  };

  const handleSearch = () => {
    if (onSearch) onSearch();
  };

  useEffect(() => {
    setIsFocused(false);
    setIsFocusedDays(false);
    setIsFocusedYears(false);
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        selectRef.current &&
        !selectRef.current.contains(event.target as Node) &&
        selectRefDays.current &&
        !selectRefDays.current.contains(event.target as Node) &&
        selectRefYears.current &&
        !selectRefYears.current.contains(event.target as Node)
      ) {
        setIsFocused(false);
        setIsFocusedDays(false);
        setIsFocusedYears(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <ContainerFlex>
      <St.Container isFocused={isFocused} disabled={disabled}>
        {label && (
          <St.Label isFocused={isFocused} disabled>
            {label}
          </St.Label>
        )}
        <St.Content>
          <St.LeftSide ref={selectRef} onClick={handleToggleFocus}>
            <St.Value>{valueSelected?.value}</St.Value>
            <St.ContainerOptions isFocused={isFocused}>
              <div>
                {months.map((month) => (
                  <div className="option" onClick={() => handleSelect(month)}>
                    {month.value}
                  </div>
                ))}
              </div>
            </St.ContainerOptions>
          </St.LeftSide>

          <St.Line />

          {showDay ? (
            <>
              <St.MidSide ref={selectRefDays} onClick={handleToggleFocusDays}>
                <St.Value>{valueDaySelected?.value}</St.Value>
                <St.ContainerOptions isFocused={isFocusedDays}>
                  <div>
                    {days.map((day) => (
                      <div
                        className="option"
                        onClick={() => handleSelectDays(day)}
                      >
                        {day.value}
                      </div>
                    ))}
                  </div>
                </St.ContainerOptions>
              </St.MidSide>

              <St.Line />
            </>
          ) : null}

          <St.RightSide ref={selectRefYears} onClick={handleToggleFocusYears}>
            <St.Value>{valueYearSelected?.value}</St.Value>
            <St.ContainerOptions isFocused={isFocusedYears}>
              <div>
                {years.map((year) => (
                  <div
                    className="option"
                    onClick={() => handleSelectYears(year)}
                  >
                    {year.value}
                  </div>
                ))}
              </div>
            </St.ContainerOptions>
          </St.RightSide>
          <St.Line />
          <St.RightSide onClick={handleSearch} style={{ cursor: 'pointer' }}>
            <button
              style={{
                background: 'transparent',
                border: 'none',
                marginTop: '5px',
              }}
            >
              <BsSearch size={20} color="#e4003a" style={{ marginLeft: 10 }} />
            </button>
          </St.RightSide>
        </St.Content>
      </St.Container>
    </ContainerFlex>
  );
};

export default SelectDate;
